import React, {Component} from 'react';
import {SORT_DEPARTURE_TIME, SORT_LOWEST_PRICE, SORT_SHORTEST_FLIGHTS} from "../../reducers/filters/SortReducer";

/**
 * Props:
 * translations array    keys'Lowest price', 'Shortest flights', 'Departure time',
 * onSortChange     callback
 * hasEmptyDefault  bool
 */
export default class SortComponent extends Component {
    renderEmptyDefault() {
        if (this.props.hasEmptyDefault) {
            return <option value="-1" >{this.props.translations['Sort by']}:</option>;
        }

        return null;
    }

    render() {
        return (
            <form>
                <select defaultValue={this.props.hasEmptyDefault ? "-1" : SORT_LOWEST_PRICE} onChange={this.props.onSortChange} className="custom-select form-control form-control-sm">
                    {this.renderEmptyDefault()}
                    <option value={SORT_LOWEST_PRICE} >{this.props.translations['Lowest price']}</option>
                    <option value={SORT_SHORTEST_FLIGHTS}>{this.props.translations['Shortest flights']}</option>
                    <option value={SORT_DEPARTURE_TIME}>{this.props.translations['Departure time']}</option>
                </select>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/SortComponent.js